import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { formatDate } from "../../../components/reusableComponent/DateFormat";
import ReactModal from "react-modal";
import EditServiceRequest from "./EditServiceRequest";
import useThemeColors from "../../vehicle/ThemeColors";
import ConfirmationModal from "./ConfirmationModal";
import CancelServiceRequest from "./CancelServiceRequest";

const GetServiceDetails = () => {
  const location = useLocation();
  const [getLocationData, setGetLocationData] = useState<any>({});
  const [isServiceRequestModalOpen, setIsServiceRequestModalOpen] =
    useState(false);
  const [isServiceConfirmModalOpen, setIsServiceConfirmModalOpen] =
    useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);

  useEffect(() => {
    if (location) {
      setGetLocationData(location?.state);
    }
  }, [location]);

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse" as const,
    border: "1px solid #ccc",
    fontWeight: 200,
  };

  const cellStyle = {
    padding: "10px",
    border: "1px solid #ccc",
  };

  const rawAddress = getLocationData?.workshop_details?.address || "";
  const addressParts = rawAddress.split(",").map((part) => part.trim());

  let pinCode = "";
  let state = "";
  let city = "";
  let addressLine = "";

  if (addressParts.length >= 3) {
    const stateAndPin = addressParts[addressParts.length - 2];
    pinCode = stateAndPin.match(/\d{6}/)?.[0] || "";
    state = stateAndPin.replace(pinCode, "").trim();
    city = addressParts[addressParts.length - 3];
    addressLine = addressParts.slice(0, addressParts.length - 3).join(", ");
  }

  const { selectedColor } = useThemeColors();

  const customModalStyles1: ReactModal.Styles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-40%, -50%)",
      width: "30%",
      border: "none",
      boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
      borderRadius: "40px",
      padding: "5px",
    },
  };

  const closeModal = () => {
    setIsServiceRequestModalOpen(false);
    setIsServiceConfirmModalOpen(false);
    setOpenCancelModal(false);
  };

  console.log(getLocationData,"getLocationData")

  return (
    <div style={{ padding: "20px", fontFamily: "karbon" }}>
      <h3 style={{ fontWeight: 200 }}>
        Appointment Details #{getLocationData?.vehicle_details?.vehicle_number}
      </h3>

      {/* Workshop Info */}
      <h4 style={{ fontWeight: 200 }}>Customer Information</h4>
      <table style={tableStyle}>
        <tbody>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Customer Name</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.customer_details?.first_name} {getLocationData?.customer_details?.last_name}
            </td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Email</strong>
            </td>
            <td style={cellStyle}>{getLocationData?.customer_details?.email}</td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Phone</strong>
            </td>
            <td style={cellStyle}>{getLocationData?.customer_details?.phone}</td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Address</strong>
            </td>
            <td style={cellStyle}>{getLocationData?.customer_details?.address}</td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>City</strong>
            </td>
            <td style={cellStyle}>{getLocationData?.customer_details?.city}</td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>State</strong>
            </td>
            <td style={cellStyle}>{getLocationData?.customer_details?.state}</td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Pincode</strong>
            </td>
            <td style={cellStyle}>{getLocationData?.customer_details?.pincode}</td>
          
          </tr>
        </tbody>
      </table>

      {/* Vehicle Info */}
      <h4 style={{ marginTop: "30px", fontWeight: 200 }}>
        Vehicle Information
      </h4>
      <table style={tableStyle}>
        <tbody>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>
                Vehicle Registration Number
              </strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.vehicle_details?.vehicle_number}
            </td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Service Type</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.service_details
                ?.map((el) => el?.name)
                .join(", ")}
            </td>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Service Date</strong>
            </td>
            <td style={cellStyle}>
              {getLocationData?.service_date
                ? formatDate(getLocationData?.service_date)
                : ""}
            </td>
          </tr>
          <tr>
            <td style={cellStyle}>
              <strong style={{ fontWeight: 200 }}>Service Details</strong>
            </td>
            <td style={cellStyle} colSpan={3}>
              {getLocationData?.service_details
                ?.flatMap((el) => el?.sub_services?.map((sub) => sub.name))
                .join(", ")}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Action Buttons */}
      {getLocationData.status !== "cancelled" &&
        getLocationData?.status !== "completed" && (
          <div style={{ marginTop: "30px", display: "flex", gap: "10px" }}>
            {/* Always allow reschedule */}
            <button
              onClick={() => setIsServiceRequestModalOpen(true)}
              style={{
                backgroundColor: "#00bcd4",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "5px",
                border: "none",
              }}
            >
              Reschedule
            </button>

            {/* Accept only if not already accepted */}
            {getLocationData?.status !== "accepted" && (
              <button
                onClick={() => setIsServiceConfirmModalOpen(true)}
                style={{
                  backgroundColor: "rgb(241, 90, 34)",
                  color: "white",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  border: "none",
                }}
              >
                Accept
              </button>
            )}

            {/* Always allow cancel */}
            <button
              onClick={() => setOpenCancelModal(true)}
              style={{
                backgroundColor: "#f44336",
                color: "#fff",
                padding: "10px 20px",
                borderRadius: "5px",
                border: "none",
              }}
            >
              Cancel
            </button>
          </div>
        )}

      {/* History Table */}
      <h4 style={{ marginTop: "40px", fontWeight: 200 }}>
        Appointment History
      </h4>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th
              style={{ textAlign: "center", padding: "10px", fontWeight: 200 }}
            >
              Scheduled Dates
            </th>
            <th
              style={{ textAlign: "center", padding: "10px", fontWeight: 200 }}
            >
              Status Updated
            </th>
            <th
              style={{ textAlign: "center", padding: "10px", fontWeight: 200 }}
            >
              Reason
            </th>
            <th
              style={{ textAlign: "center", padding: "10px", fontWeight: 200 }}
            >
              Updated By
            </th>
            <th
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "10px",
                fontWeight: 200,
              }}
            >
              Action
            </th>
          </tr>
        </thead>

        <tbody>
          {getLocationData?.appointment_logs?.map((el, ind) => (
            <tr
              key={ind}
              style={{
                background: ind % 2 === 0 ? "#d2d0d0" : "white",
                color: "black",
                padding: "10px",
                width: "100%",
              }}
            >
              <td
                style={{
                  textAlign: "center",
                  color: "#888",
                  padding: "10px",
                  fontWeight: 200,
                }}
              >
                {formatDate(el?.created_at)}
              </td>
              <td
                style={{
                  textAlign: "center",
                  color: "#888",
                  padding: "10px",
                  fontWeight: 200,
                }}
              >
                {el?.new_status}
              </td>
              <td
                style={{
                  padding: "10px",
                  textAlign: "center",
                  fontWeight: 200,
                }}
              >
                <div
                  style={{
                    width: "150px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "#888",
                    margin: "0 auto",
                  }}
                  title={el?.notes}
                >
                  {el?.notes}
                </div>
              </td>
              <td
                style={{
                  textAlign: "center",
                  color: "#888",
                  padding: "10px",
                  fontWeight: 200,
                }}
              >
                {el?.user_type}
              </td>
              <td
                style={{
                  textAlign: "center",
                  color: "#888",
                  padding: "10px",
                  fontWeight: 200,
                }}
              >
                {el?.action}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modals */}
      <ReactModal
        isOpen={isServiceRequestModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles1}
      >
        <EditServiceRequest
          closeModal={closeModal}
          requestedId={getLocationData?.id}
        />
      </ReactModal>

      <ReactModal
        isOpen={isServiceConfirmModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles1}
      >
        <ConfirmationModal
          closeModal={closeModal}
          requestedId={getLocationData?.id}
        />
      </ReactModal>

      <ReactModal
        isOpen={openCancelModal}
        onRequestClose={closeModal}
        style={customModalStyles1}
      >
        <CancelServiceRequest
          closeModal={closeModal}
          requestedId={getLocationData?.id}
        />
      </ReactModal>
    </div>
  );
};

export default GetServiceDetails;
